module.exports = __webpack_public_path__ + "img/ch2.0e3f2689.jpeg";